(function() {
  const isRtl = document.documentElement.dir === 'rtl';

  const _attachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(init) {
    const shadow = _attachShadow.call(this, init);
    if (this.matches && this.matches('.gw-rd-earn-points-product-page-widget-placeholder')) {
      const ensureTransparentStyle = () => {
        if (shadow.querySelector('style[data-custom="gw-points-purchase-early"]')) return;
        const earlyStyle = document.createElement('style');
        earlyStyle.setAttribute('data-custom', 'gw-points-purchase-early');
        earlyStyle.textContent = `
          .gw-rd-earn-points-product-page-widget__points-purchase {
            background: transparent !important;
            background-color: transparent !important;
          }
        `;
        shadow.appendChild(earlyStyle);
      };
      ensureTransparentStyle();
      const earlyObserver = new MutationObserver(ensureTransparentStyle);
      earlyObserver.observe(shadow, { childList: true, subtree: true });

      if (this.closest('.product__price')) {
        this.style.setProperty('display', 'none', 'important');
      }
    }
    return shadow;
  };

  function isInsideCartDrawerBody(el) {
    return !!el.closest('.cart-drawer__body');
  }

  function hideSvg() {
    const placeholder = document.querySelector('.gw-rd-earn-points-cart-widget-placeholder');
    if (!placeholder) return false;
    if (isInsideCartDrawerBody(placeholder)) return false;
    const root = placeholder.shadowRoot || placeholder;
    const svg = root.querySelector('svg');
    if (!svg) return false;
    svg.remove();
    placeholder.classList.add('gw-svg-removed');
    return true;
  }

  if (!hideSvg()) {
    const svgObserver = new MutationObserver(() => {
      if (hideSvg()) svgObserver.disconnect();
    });
    svgObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => svgObserver.disconnect(), 15000);
  }

  function hideCartBodySvgs() {
    const cartBody = document.querySelector('.cart__body');
    if (!cartBody) return false;
    const placeholders = cartBody.querySelectorAll('.gw-rd-earn-points-cart-widget-placeholder');
    if (!placeholders.length) return false;
    placeholders.forEach(p => {
      const root = p.shadowRoot || p;
      const svg = root.querySelector('svg');
      if (svg) {
        svg.style.setProperty('display', 'none', 'important');
        p.classList.add('gw-svg-removed');
      }
    });
    return true;
  }

  hideCartBodySvgs();
  const cartBodyObserver = new MutationObserver(hideCartBodySvgs);
  cartBodyObserver.observe(document.body, { childList: true, subtree: true });

  const injectedDrawerRoots = new WeakSet();

  function fixCartDrawerVisibility() {
    const drawerBody = document.querySelector('.cart-drawer__body');
    if (!drawerBody) return;
    const placeholders = drawerBody.querySelectorAll('.gw-rd-earn-points-cart-widget-placeholder');
    placeholders.forEach(p => {
      p.style.setProperty('visibility', 'visible', 'important');
      p.style.setProperty('display', 'block', 'important');
      p.style.setProperty('opacity', '1', 'important');
      p.style.setProperty('margin-bottom', '20px', 'important');
      const shadowRoot = p.shadowRoot;
      if (shadowRoot && !injectedDrawerRoots.has(shadowRoot)) {
        const style = document.createElement('style');
        style.setAttribute('data-custom', 'cart-drawer-styles');
        style.textContent = `
          .gw-badge--tone-info { background-color: #999b311a !important; }
          .gw-text { font-family: "Aktiv Regular", sans-serif !important; }
        `;
        shadowRoot.appendChild(style);
        injectedDrawerRoots.add(shadowRoot);
      }
    });
  }

  fixCartDrawerVisibility();
  const visibilityObserver = new MutationObserver(fixCartDrawerVisibility);
  visibilityObserver.observe(document.body, { childList: true, subtree: true });

  function applyStyles() {
    const placeholder = document.querySelector('.gw-rd-earn-points-cart-widget-placeholder');
    if (!placeholder) return false;
    if (isInsideCartDrawerBody(placeholder)) return false;
    const root = placeholder.shadowRoot || placeholder;
    const badgeInfo = root.querySelector('.gw-badge--tone-info');
    const text = root.querySelector('.gw-text.gw-text--body-sm');
    const badges = root.querySelectorAll('.gw-badge');
    const badgeIcons = root.querySelectorAll('.gw-badge__icon');
    if (!badgeInfo && !text && !badges.length) return false;
    if (badgeInfo) badgeInfo.style.setProperty('padding', '8px', 'important');
    if (badgeInfo) badgeInfo.style.setProperty('border', '1px solid rgba(0,66,54,.2)', 'important');
    if (badgeInfo) badgeInfo.style.setProperty('border-radius', '4px', 'important');
    if (text) {
      text.style.setProperty('font-weight', 'bold', 'important');
      text.style.setProperty('font-size', '14px', 'important');
      const fontFamily = isRtl ? "'29LTZaridDisplay Medium', serif" : "'Recoleta Medium', serif";
      text.style.setProperty('font-family', fontFamily, 'important');
    }
    badges.forEach(b => {
      b.style.setProperty('display', 'flex', 'important');
      b.style.setProperty('justify-content', isRtl ? 'right' : 'left', 'important');
    });
    badgeIcons.forEach(i => i.style.setProperty('display', 'none', 'important'));
    return true;
  }

  applyStyles();
  const styleObserver = new MutationObserver(applyStyles);
  styleObserver.observe(document.body, { childList: true, subtree: true });

  if (isRtl) {
    const rtlCss = `.gw-text, span.gw-layout-text { font-family: '29LTZaridDisplay Medium', serif !important; }`;
    const injectedRoots = new WeakSet();
    const injectRtlFont = (root) => {
      if (!root || injectedRoots.has(root)) return;
      const style = document.createElement('style');
      style.setAttribute('data-custom', 'rtl-font');
      style.textContent = rtlCss;
      root.appendChild(style);
      injectedRoots.add(root);
    };
    const scanShadowRoots = (node) => {
      if (!node || !node.querySelectorAll) return;
      if (node.shadowRoot) { injectRtlFont(node.shadowRoot); scanShadowRoots(node.shadowRoot); }
      const all = node.querySelectorAll('*');
      for (const el of all) {
        if (el.shadowRoot) { injectRtlFont(el.shadowRoot); scanShadowRoots(el.shadowRoot); }
      }
    };
    if (document.head) injectRtlFont(document.head);
    scanShadowRoots(document);
    const rtlObserver = new MutationObserver(() => scanShadowRoots(document));
    rtlObserver.observe(document.body, { childList: true, subtree: true });
  }

  const injectedProductRoots = new WeakSet();
  const rewardLabel = isRtl ? 'نقطة مكافأة' : 'Reward Points';

  function customizeProductPageWidget() {
    const placeholders = document.querySelectorAll('.product__price .gw-rd-earn-points-product-page-widget-placeholder');
    if (!placeholders.length) return false;

    let didSomething = false;

    placeholders.forEach(placeholder => {
      const root = placeholder.shadowRoot || placeholder;

      const content = root.querySelector('.gw-rd-earn-points-product-page-widget__content');
      if (!content) return;

      const imageWrapper = content.querySelector('.gw-rd-earn-points-product-page-widget__image-wrapper');
      if (imageWrapper) {
        imageWrapper.style.setProperty('display', 'none', 'important');
        didSomething = true;
      }
      const btns = content.querySelectorAll('.gw-btn');
      btns.forEach(btn => {
        btn.style.setProperty('display', 'none', 'important');
        didSomething = true;
      });

      const layoutSpans = root.querySelectorAll('span.gw-layout-text');
      layoutSpans.forEach(span => {
        const original = span.textContent || '';
        const match = original.match(/\d+/);
        if (!match) return;
        const points = match[0];
        const desired = `${points} ${rewardLabel}`;
        if (span.textContent !== desired) {
          span.textContent = desired;
          didSomething = true;
        }
        span.style.setProperty('color', '#004236', 'important');
        span.style.setProperty('font-size', '14px', 'important');
        const fontFamily = isRtl ? "'29LTZaridDisplay Medium', serif" : '"Recoleta Medium", sans-serif';
        span.style.setProperty('font-family', fontFamily, 'important');
      });

      if (placeholder.shadowRoot && !injectedProductRoots.has(placeholder.shadowRoot)) {
        const style = document.createElement('style');
        style.setAttribute('data-custom', 'product-page-widget-styles');
        const fontFamily = isRtl ? "'29LTZaridDisplay Medium', serif" : '"Recoleta Medium", sans-serif';
        style.textContent = `
          .gw-rd-earn-points-product-page-widget__content .gw-rd-earn-points-product-page-widget__image-wrapper { display: none !important; }
          .gw-rd-earn-points-product-page-widget__content .gw-btn { display: none !important; }
          .gw-rd-earn-points-product-page-widget__content {
            border: 1px solid rgba(0,66,54,.2) !important;
            border-radius: 4px !important;
            background: #FFFFFF !important;
            padding: 8px !important;
          }
          span.gw-layout-text { color: #004236 !important; font-family: ${fontFamily} !important; font-size: 14px !important; }
          .gw-rd-earn-points-product-page-widget__points-purchase { background-color: transparent !important; }
          .gw-rd-earn-points-product-page-widget__points-purchase .gw-layout-text { color: #004236 !important; }
        `;
        placeholder.shadowRoot.appendChild(style);
        injectedProductRoots.add(placeholder.shadowRoot);
        didSomething = true;
      }

      content.style.setProperty('border', '1px solid rgba(0,66,54,.2)', 'important');
      content.style.setProperty('border-radius', '4px', 'important');
      content.style.setProperty('background', '#FFFFFF', 'important');

      placeholder.style.setProperty('display', 'block', 'important');
    });

    return didSomething;
  }

  customizeProductPageWidget();
  const productWidgetObserver = new MutationObserver(customizeProductPageWidget);
  productWidgetObserver.observe(document.body, { childList: true, subtree: true });

  function isCustomerLoggedIn() {
    if (window.__st && window.__st.cid) return true;
    if (document.body.classList.contains('customer-logged-in')) return true;
    if (document.querySelector('a[href*="/account/logout"]')) return true;
    return false;
  }

  function customizeCartWidgetText() {
    const loggedIn = isCustomerLoggedIn();
    const containers = ['.cart__summary-wrapper', '.cart-drawer__bottom'];
    let didSomething = false;

    containers.forEach(containerSelector => {
      const placeholders = document.querySelectorAll(
        `${containerSelector} .gw-rd-earn-points-cart-widget-placeholder`
      );
      placeholders.forEach(placeholder => {
        const root = placeholder.shadowRoot || placeholder;
        const textEl = root.querySelector('.gw-text');
        if (!textEl) return;

        const original = textEl.textContent || '';
        const match = original.match(/\d+/);
        if (!match) return;
        const points = match[0];

        let desiredText;
        if (isRtl) {
          // RTL (Arabic) site -> always Arabic
          desiredText = loggedIn
            ? `ستكسب ${points} نقطة ولاء مع طلبك.`
            : `اكسب ${points} نقطة مع نادي Love Your Body™. سجّل الدخول أو أنشئ حسابًا عند إتمام الشراء.`;
        } else {
          // LTR (English) site -> always English
          desiredText = loggedIn
            ? `You'll earn ${points} loyalty points with your order.`
            : `Earn ${points} points with Love Your Body™ Club. Login or sign-up at checkout.`;
        }

        if (textEl.textContent !== desiredText) {
          textEl.textContent = desiredText;
          didSomething = true;
        }

        // Force 12px / Aktiv Regular regardless of what applyStyles or
        // fixCartDrawerVisibility already set on this element.
        textEl.style.setProperty('font-size', '12px', 'important');
        textEl.style.setProperty('font-family', '"Aktiv Regular", sans-serif', 'important');
      });
    });

    return didSomething;
  }

  customizeCartWidgetText();
  const cartWidgetTextObserver = new MutationObserver(customizeCartWidgetText);
  cartWidgetTextObserver.observe(document.body, { childList: true, subtree: true });

  // Force transparent background on the points-purchase element (injected later by the app,
  // possibly inside nested shadow roots). Inline !important beats any app style.
  function forceTransparentPointsPurchase(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.gw-rd-earn-points-product-page-widget__points-purchase').forEach(el => {
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-color', 'transparent', 'important');
    });
    root.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) forceTransparentPointsPurchase(el.shadowRoot);
    });
  }

  forceTransparentPointsPurchase(document);
  const pointsPurchaseObserver = new MutationObserver(() => forceTransparentPointsPurchase(document));
  pointsPurchaseObserver.observe(document.body, { childList: true, subtree: true });

  // Style the earn-points widget only when it appears inside a .product-grid.
  // Scoped per shadow root: we only inject into roots whose host is under .product-grid.
  const injectedGridRoots = new WeakSet();

  function customizeProductGridWidgets() {
    const placeholders = document.querySelectorAll('.product-grid .gw-rd-earn-points-product-page-widget-placeholder');
    // Only the 2nd widget — the 1st one already has its own border (applying ours doubles it up).
    const target = placeholders[1];
    if (!target) return;
    const shadowRoot = target.shadowRoot;
    if (!shadowRoot || injectedGridRoots.has(shadowRoot)) return;
    const style = document.createElement('style');
    style.setAttribute('data-custom', 'product-grid-widget-styles');
    style.textContent = `
      .gw-rd-earn-points-product-page-widget__points-purchase { color: #004236 !important; }
      .gw-rd-earn-points-product-page-widget__earn-points {
        border: 1px solid rgba(0, 66, 54, 0.2) !important;
        border-radius: 4px !important;
        background: rgb(255, 255, 255) !important;
        padding: 8px !important;
      }
      .gw-rd-earn-points-product-page-widget__earn-points .gw-layout-text {
        min-width: 120px !important;
      }
    `;
    shadowRoot.appendChild(style);
    injectedGridRoots.add(shadowRoot);
  }

  customizeProductGridWidgets();
  const productGridWidgetObserver = new MutationObserver(customizeProductGridWidgets);
  productGridWidgetObserver.observe(document.body, { childList: true, subtree: true });
})();